export default __webpack_public_path__ + "static/media/Select_arrow2.efe14026.svg";